<template>
  <v-container id="myApplication">
    <v-col cols="12" md="4">
      <v-autocomplete
        :name="contractor"
        v-model="contractor"
        :items="itemList"
        @change="onChangeContractor"
        label="Sélectionnez un DO"
        solo
        outlined
        dense
        width="250px"
        hide-details
      >
        <template v-slot:selection="{ item }"> {{ item.label }} </template>
        <template v-slot:item="{ item }"> {{ item.code }} - {{ item.label }} </template>
      </v-autocomplete>
    </v-col>
    <listLogisticVariantComponent ref="form" :controller="controller" id="listLogisticVariantComponent"></listLogisticVariantComponent>
    <div class="text-center">
      <v-btn outlined @click="openModalLockUnlok('B')" class="ma-1">Bloquer</v-btn>
      <v-btn outlined @click="openModalLockUnlok('D')" class="ma-1">Débloquer</v-btn>
    </div>
    <formLogisticVariantLockComponent :controller="controller" id="listLogisticVariantComponent"></formLogisticVariantLockComponent>
  </v-container>
</template>

<script>
import logisticVariantController from "../shared/services/controllers/logisticVariant/logisticVariantController";
import listLogisticVariantComponent from "./components/list/listLogisticVariant.vue";
import formLogisticVariantLockComponent from "./components/form/formLogisticVariantLockComponent.vue";
import { apiUrls } from "@/environment/environment";

export default {
  name: "componentsUpdate",

  components: {
    listLogisticVariantComponent,
    formLogisticVariantLockComponent
  },

  data() {
    return {
      controller: {},

      selectedElement: null,
      contractor: null,
      itemList: [],

      blockingType: null
    };
  },
  watch: {},

  computed: {},

  methods: {
    retrieveController() {
      let logisticVariantBaseUrl = apiUrls.logisticVariant;
      this.controller = new logisticVariantController(logisticVariantBaseUrl);
    },

    openModalLockUnlok(blockingType) {
      this.blockingType = blockingType;
      if (this.selectedElement) {
        this.controller.EventBus.$emit("showModal", blockingType, this.selectedElement);
      }
    },

    async selectedlogisticVariant(selectedElement) {
      this.selectedElement = selectedElement;
    },

    onChangeContractor() {
      this.controller.EventBus.$emit("refreshList", this.contractor);
      this.selectedElement = null;
    },

    async retrieveItems(suggest) {
      try {
        this.isLoading = true;
        this.itemList = [];

        await this.controller.LogisticVariantStore.getDataSuggest(suggest).then(response => {
          this.itemList = response;
          this.isLoading = false;
        });
      } catch (e) {
        this.controller.Notification.notifyInfo("retrieveItems - inputComponent error", e);
      }
    }
  },

  mounted() {
    this.retrieveItems();
  },

  async beforeMount() {
    this.controller.EventBus.$on("closeModal", await this.closeModal);
  },

  async beforeDestroy() {
    this.controller.EventBus.$off("closeModal", await this.closeModal);
  },
  created() {
    this.retrieveController();
  }
};
</script>

<style lang="scss" scoped></style>
